import { render, staticRenderFns } from "./ClientGroupedView.vue?vue&type=template&id=7d3610ac&scoped=true"
import script from "./ClientGroupedView.vue?vue&type=script&lang=js"
export * from "./ClientGroupedView.vue?vue&type=script&lang=js"
import style0 from "./ClientGroupedView.vue?vue&type=style&index=0&id=7d3610ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3610ac",
  null
  
)

export default component.exports